import Nullstack from 'nullstack';
export default function IconSpray({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-spray",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "10",
    width: "8",
    height: "11",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M6 10v-4a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4"
  }), "   ", Nullstack.element("path", {
    d: "M15 7h.01"
  }), "   ", Nullstack.element("path", {
    d: "M18 9h.01"
  }), "   ", Nullstack.element("path", {
    d: "M18 5h.01"
  }), "   ", Nullstack.element("path", {
    d: "M21 3h.01"
  }), "   ", Nullstack.element("path", {
    d: "M21 7h.01"
  }), "   ", Nullstack.element("path", {
    d: "M21 11h.01"
  }), "   ", Nullstack.element("path", {
    d: "M10 7h1"
  }), " ");
}